export { default } from './ArtistRecordings';
